<template>
    <div id="food_menu" ref="food_menu" class="hidden">
    <section class="pages section-dltable" id="menu" data-gjs-type="dltable">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2>Weekly Menu</h2>
                <div>
                    <div class="col-md-12" v-for="item in Menu" :key="item.id">
                        <h3>{{item.name}}</h3>
                        <div class="menu_cal breakfast fc fc-ltr">
                            <table class="fc-header" style="width:100%">
                                <tbody>
                                    <tr>
                                        <td class="fc-header-left"><span class="fc-header-title">
                                                <!-- <h6>Oct 4 — 8 2021</h6> -->
                                            </span></td>
                                        <td class="fc-header-center"></td>
                                        <td class="fc-header-right"><span
                                                class="fc-button fc-button-today fc-state-default fc-corner-left fc-corner-right fc-state-disabled"
                                                unselectable="on" style="display: none;">today</span><span
                                                class="fc-header-space"></span><span
                                                class="fc-button fc-button-prev fc-state-default fc-corner-left"
                                                unselectable="on" style="display: none;"><span
                                                    class="fc-text-arrow">‹</span></span><span
                                                class="fc-button fc-button-next fc-state-default fc-corner-right"
                                                unselectable="on" style="display: none;"><span
                                                    class="fc-text-arrow">›</span></span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="fc-content" style="position: relative;">
                                <div class="fc-view fc-view-basicWeek fc-grid" style="position:relative"
                                    unselectable="on">
                                    <div class="fc-event-container" style="position:absolute;z-index:8;top:0;left:0" >
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 2px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[0].value}}</span></div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 218px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[1].value}}</span></div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 434px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[2].value}}</span></div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 650px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[3].value}}</span>
                                            </div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 866px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[4].value}}</span></div>
                                        </div>
                                    </div>
                                    <table class="fc-border-separate" style="width:100%" cellspacing="0">
                                        <thead>
                                            <tr class="fc-first fc-last">
                                                <th class="fc-day-header fc-mon fc-widget-header fc-first" :key="index" v-for="(day,index) in item.days" v-if="index<5"
                                                    style="width: 216px;">{{day.day.charAt(0).toUpperCase()+day.day.charAt(1).toUpperCase()+day.day.charAt(2).toUpperCase()}} {{day.date}}</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="fc-week fc-first fc-last">
                                                <td class="fc-day fc-mon fc-widget-content fc-past fc-first"
                                                    data-date="2021-10-04">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-tue fc-widget-content fc-past"
                                                    data-date="2021-10-05">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-wed fc-widget-content fc-past"
                                                    data-date="2021-10-06">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-thu fc-widget-content fc-past"
                                                    data-date="2021-10-07">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-fri fc-widget-content fc-today fc-state-highlight fc-last"
                                                    data-date="2021-10-08">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    </div>
</template>
<script>
import {
  program_temp,
} from "./../ProgramTemplate";
import {
    MAKE_FOOD_MENU
} from '@/graphql'
export default {
  props: {
    isData: {
      type: Boolean,
      default:false
    },
    site: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    
 

  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      weeks:[],
      Menu:[],
        main:program_temp,
   

    }
  },
  watch: {
    isData (val) {
          this.getMenu(this.site.siteName)
    },
  },
  computed: {
  },
  methods: {
     createMenu(){
        let doc = new DOMParser().parseFromString(this.main, "text/html");
              var d1 = doc.getElementById("sb-addsection");
               d1.replaceWith(this.$refs.food_menu);
              this.$emit('setFoodMenu',this.$refs.food_menu.innerHTML)
     },
     getMenu(site){
      this.$apollo
        .mutate({
          mutation: MAKE_FOOD_MENU,
          variables: {
            site:site
          }
        })
        .then(response => {
          if(response.data.makeFoodMenu.status==='Success'){
            this.Menu =JSON.parse(response.data.makeFoodMenu.data);
              this.$nextTick(() => {
                  this.createMenu()
                })
            
          }
        }).catch(error => {
          console.log(error)
        })
     },
  },
  created(){
  }

}
</script>
